import Vue from 'vue'

import ZkUi from '@/cdpBase/index.js'
import noData from '@/components/isNoData.vue'
import threeColumn from '@/layout/threeColumn.vue'
import twoColumn from '@/layout/twoColumn.vue'
import threeRow from '@/layout/threeRow.vue'
import content from '@/layout/content.vue'
import deviceStatus from '@/modules/comComponent/deviceStatus'
import tabs from '@/components/tabs.js'
import pane from '@/components/pane.js'
import loadding from '@/components/loadding.vue'
import verifyPhoto from '@/modules/comComponent/verifyPhoto'
import ZKtecoTable from '@/modules/comComponent/ZKtecoTable'
Vue.use(ZkUi)
Vue.component('tabs', tabs)
Vue.component('pane', pane)
Vue.component('zkLoading', loadding)
Vue.component(content.name, content)
Vue.component('deviceStatus', deviceStatus)
Vue.component(threeColumn.name, threeColumn)
Vue.component(twoColumn.name, twoColumn)
Vue.component(threeRow.name, threeRow)
Vue.component(noData.name, noData)
Vue.component(verifyPhoto.name, verifyPhoto)
Vue.component(ZKtecoTable.name, ZKtecoTable)



// WEBPACK FOOTER //
// ./src/pages/index/registerZkComponet.js